// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import "babel-polyfill";
require('es6-promise').polyfill();
require('es6-promise/auto');
import Vue from 'vue'
import App from './App'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'
import {post,fetch,patch,put} from './api/http'
import store from './store/'
import global from './api/globalVariable'

import iView from 'iview';
import 'iview/dist/styles/iview.css';
import 'static/css/index.less';
import 'static/css/public.less';
import Timeformater  from 'zhouqjtest';
Vue.prototype.timeformater = Timeformater
Vue.prototype.$post=post;
Vue.prototype.$fetch=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
Vue.prototype.$global=global;

Vue.use(VueWechatTitle);
Vue.use(iView);
Vue.config.productionTip = false;

import animated from 'animate.css' // npm install animate.css --save安装，在引入
import 'swiper/dist/css/swiper.css';
Vue.use(animated)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js